module.exports = __webpack_public_path__ + "img/Slider-1.267b1f21.jpg";